
/* ======================================================
   SPACE AVAILABLE — COMMUNITY CALENDAR
   JavaScript V2.0

   01 — Animation Settings
   02 — Open / Close Animation
   03 — Accordion Behavior
   04 — Initialization
   05 — Shopify Theme Editor
   ====================================================== */

(() => {
  'use strict';


/* ANIMATION SETTINGS */

/* Opening — slower and smoother */
const OPEN_DURATION = 700;
const OPEN_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

/* Closing — keep original */
const CLOSE_DURATION = 420;
const CLOSE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';


  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );


  /* ==============================================
     02 — GET EVENT STATE
     ============================================== */

  const isExpanded = (event) => {

    const intended = event.dataset.saTargetOpen;

    if (intended !== undefined) {
      return intended === 'true';
    }

    return event.open;

  };


  /* ==============================================
     03 — SMOOTH OPEN / CLOSE
     ============================================== */

  const setEventOpen = (
    event,
    shouldOpen,
    animated = true
  ) => {

    if (isExpanded(event) === shouldOpen) {
      return;
    }

    const summary = event.querySelector('summary');

    const panel = event.querySelector(
      '.sa-calendar__panel'
    );

    if (!summary || !panel) return;

    /* Capture current height */

    const startHeight =
      event.getBoundingClientRect().height;

    /* Cancel previous animation */

    if (event._saAnimation) {
      event._saAnimation.cancel();
      event._saAnimation = null;
    }

    event.style.height = '';
    event.style.overflow = '';

    /* Reduced-motion / fallback */

    if (
      !animated ||
      reducedMotion.matches ||
      typeof event.animate !== 'function'
    ) {

      event.open = shouldOpen;

      delete event.dataset.saTargetOpen;

      return;
    }

    /* Record intended state */

    event.dataset.saTargetOpen = String(
      shouldOpen
    );

    event.style.overflow = 'hidden';
    event.style.height = `${startHeight}px`;

    /* Make content measurable */

    if (shouldOpen) {
      event.open = true;
    }

    const summaryHeight = summary.offsetHeight;
    const panelHeight = panel.offsetHeight;

    const endHeight = shouldOpen
      ? summaryHeight + panelHeight
      : summaryHeight;

    /* Animate height */

    const animation = event.animate(
      [
        {
          height: `${startHeight}px`
        },
        {
          height: `${endHeight}px`
        }
      ],
      
{
  duration: shouldOpen
    ? OPEN_DURATION
    : CLOSE_DURATION,

  easing: shouldOpen
    ? OPEN_EASING
    : CLOSE_EASING,

  fill: 'forwards'
}

    );

    event._saAnimation = animation;

    /* Finalize state */

    animation.onfinish = () => {

      if (event._saAnimation !== animation) {
        return;
      }

      event.open = shouldOpen;

      animation.cancel();

      event.style.height = '';
      event.style.overflow = '';

      delete event.dataset.saTargetOpen;

      event._saAnimation = null;

    };

  };


  /* ==============================================
     04 — ACCORDION BEHAVIOR
     ============================================== */

  const setupCalendar = (calendar) => {

    if (!calendar) return;

    if (
      calendar.dataset.saCalendarReady === 'true'
    ) {
      return;
    }

    calendar.dataset.saCalendarReady = 'true';

    const events = Array.from(
      calendar.querySelectorAll('[data-sa-event]')
    );

    /* No default opened events */

    events.forEach((event) => {
      event.open = false;
    });

    /* Event interactions */

    events.forEach((event) => {

      const summary = event.querySelector('summary');

      if (!summary) return;

      summary.addEventListener('click', (clickEvent) => {

        /* Stop native instant opening */

        clickEvent.preventDefault();

        const shouldOpen = !isExpanded(event);

        /* Close all other events */

        if (shouldOpen) {

          events.forEach((otherEvent) => {

            if (otherEvent !== event) {

              setEventOpen(
                otherEvent,
                false,
                true
              );

            }

          });

        }

        /* Animate selected event */

        setEventOpen(
          event,
          shouldOpen,
          true
        );

      });

    });

  };


  /* ==============================================
     05 — INITIALIZE
     ============================================== */

  const init = (container = document) => {

    if (
      container.matches &&
      container.matches('[data-sa-calendar]')
    ) {
      setupCalendar(container);
    }

    container
      .querySelectorAll('[data-sa-calendar]')
      .forEach(setupCalendar);

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );

  } else {

    init();

  }


  /* ==============================================
     06 — SHOPIFY THEME EDITOR
     ============================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      init(event.target);

    }
  );


  /* ==============================================
     07 — AUTO OPEN SELECTED BLOCK
     Only within Shopify Theme Editor
     ============================================== */

  document.addEventListener(
    'shopify:block:select',
    (event) => {

      const selectedEvent =
        event.target.closest('[data-sa-event]');

      if (!selectedEvent) return;

      const calendar =
        selectedEvent.closest('[data-sa-calendar]');

      if (!calendar) return;

      const events = calendar.querySelectorAll(
        '[data-sa-event]'
      );

      events.forEach((otherEvent) => {

        if (otherEvent !== selectedEvent) {

          setEventOpen(
            otherEvent,
            false,
            false
          );

        }

      });

      setEventOpen(
        selectedEvent,
        true,
        false
      );

      selectedEvent.scrollIntoView({
        behavior: 'auto',
        block: 'nearest'
      });

    }
  );

})();
